export default {"src":"/_next/static/media/hexagon-fill.fa1c55c7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};